import { useState } from 'react';
import { searchCustomer } from 'src/apis/customerApi';
import useUiuxStore from 'src/store/useUiuxStore';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { defaultSAL3050_R01Filter, useSAL3050_R01Store } from './Store_SAL3050_R01';
import { SearchSectionForm } from 'src/components/common/form/search/SearchSectionForm';
import { SearchDropDownForm } from 'src/components/common/form/search/SearchDropDownForm';
import { SearchDateRangeForm } from 'src/components/common/form/search/SearchDateRangeForm';
import { SearchCodeModalForm } from 'src/components/common/form/search/SearchCodeModalForm';
import { useInfoFormEvents } from 'src/hooks/useInfoFormEvents';
import { InfoCodeSearchFieldConfig } from 'src/types/info-form';

export const SearchSection_SAL3050_R01 = () => {
    const { SAL3050_R01Filter, setSAL3050_R01Filter } = useSAL3050_R01Store();
    const { setCodeSearchModalProps } = useUiuxStore();
    const { areaCdList } = useCommonCodeStore();

    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

    const custFocusId = 'custInput_SAL3050_search';

    const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
        {
            fieldName: 'customCd',
            category: '거래처',
            focusId: custFocusId,
            responseMapping: { customCd: 'customCd', customNm: 'customNm' },
            searchFunction: async (searchText: string) => {
                const res = await searchCustomer(searchText);
                return res.data.data.find((v) => v.customCd === searchText);
            },
            extraFilter: () => ({
                customCd: SAL3050_R01Filter.customCd || '',
                customNm: SAL3050_R01Filter.customNm || '',
            }),
        },
    ];

    const { getFieldHandlers } = useInfoFormEvents({
        editData: SAL3050_R01Filter,
        setEditData: setSAL3050_R01Filter,
        defaultData: defaultSAL3050_R01Filter,
        infoFieldConfigs,
        setCodeSearchModalProps,
        formName: 'SAL3050_R01_search',
    });

    return (
        <SearchSectionForm>
            <SearchDropDownForm
                label="영업지역"
                value={SAL3050_R01Filter.areaCd}
                optionList={areaCdList}
                onChangeValue={(v) => setSAL3050_R01Filter({ areaCd: v })}
                wrapperOption={{
                    wrapperStyle: 'w-[200px] min-w-[200px] mr-[10px]',
                    titleStyle: 'w-[55px] min-w-[55px]',
                    selectStyle: 'w-[110px] min-w-[110px]',
                }}
            />

            <SearchDateRangeForm
                label="기간"
                wrapperOption={{
                    titleStyle: 'h-[24px] flex items-center truncate shrink-0 w-[40px] min-w-[40px]',
                }}
                visible={pickerVisible}
                setVisible={setPickerVisible}
                dateRange={SAL3050_R01Filter.dateRange}
                setDateRange={(dateRange) => setSAL3050_R01Filter({ dateRange })}
                pickerPosition={pickerPosition}
                setPickerPosition={setPickerPosition}
            />

            <SearchCodeModalForm
                label="거래처"
                value={SAL3050_R01Filter.customCd}
                valueLabel={SAL3050_R01Filter.customNm}
                handleFoucsId={custFocusId}
                onChange={getFieldHandlers('customCd').onChange}
                onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
                onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
            />
        </SearchSectionForm>
    );
};
